import {Injectable} from '@angular/core';
import {PhysicalAsset} from '../models/physical-asset';
import {environment} from "@environments/environment";
import {map} from "rxjs/operators";
import {ApiResponse, ApiStatus} from "../models/api-response";
import {HttpClient} from "@angular/common/http";
import {UiManagerService} from "./ui-manager.service";
import {RestApiManager} from "./rest-api-manager";
import {Equipment} from "../models/equipment";
import {Paginator} from "../models/paginator";
import {FieldService} from "../models/field-service";
import {AccountManagerService} from "./account-manager-service";

@Injectable({
  providedIn: 'root'
})
export class PhysicalAssetManagerService {

  constructor(
    private accountManager: AccountManagerService,
    private httpClient: HttpClient,
    private uiManagerService: UiManagerService,
    private restApiManager: RestApiManager,
  ) { }

  async getPhysicalAssets(equipmentId: string, query?: string, paginator?: Paginator<PhysicalAsset>): Promise<PhysicalAsset[]> {
    return this.restApiManager.getAll<PhysicalAsset>(
      PhysicalAsset,
      `${environment.restApi.endpoint}/equipmentsWithLastMaintenance/search`,
      this.accountManager.account.authToken,
      { paginator, params: { companyId: this.accountManager.account.company.id, modelId: equipmentId, q: query || '' } },
    );
  }

  async getPhysicalAsset(physicalAssetId: string): Promise<PhysicalAsset> {
    return this.restApiManager.get<PhysicalAsset>(
      PhysicalAsset,
      `${environment.restApi.endpoint}/equipments/${physicalAssetId}`,
      this.accountManager.account.authToken
    );
  }

  async createPhysicalAsset(physicalAsset: PhysicalAsset): Promise<PhysicalAsset> {
    return this.restApiManager.post<PhysicalAsset>(
      `${environment.restApi.endpoint}/equipments`,
      physicalAsset,
      this.accountManager.account.authToken
    );
  }

  async updatePhysicalAsset(physicalAssetId: string, physicalAsset: PhysicalAsset): Promise<PhysicalAsset> {
    return this.restApiManager.put<PhysicalAsset>(
      `${environment.restApi.endpoint}/equipments/${physicalAssetId}`,
      physicalAsset,
      this.accountManager.account.authToken
    );
  }

  async removePhysicalAsset(physicalAssetId: string): Promise<void> {
    return this.restApiManager.delete(
      `${environment.restApi.endpoint}/equipments/${physicalAssetId}`,
      this.accountManager.account.authToken
    );
  }

  async getPhysicalAssetsFromFieldService(fieldService: FieldService, query: string, paginator?: Paginator<PhysicalAsset>): Promise<PhysicalAsset[]> {
    return this.restApiManager.getAll<PhysicalAsset>(
      PhysicalAsset,
      // `${environment.restApi.endpoint}/field_services/${fieldService.id}/equipments`,
      `${environment.restApi.endpoint}/equipmentsWithLastMaintenance/search`,
      this.accountManager.account.authToken,
      { paginator, params: { companyId: this.accountManager.account.company.id, fieldServiceId: fieldService.id, q: query || '' } },
    );
  }

  // TODO
  async importPhysicalAssets(equipmentId: string, file: File): Promise<ApiStatus> {

    // Prepare data to send
    const formData = new FormData();
    formData.append('uid', this.accountManager.account.company.id);
    formData.append('equipmentId', equipmentId);
    formData.append('assets', file);

    const response = await this.httpClient.post(environment.apiEndpoint + '/asset/import', formData).pipe(map(x => x as ApiResponse)).toPromise<ApiResponse>();
    if (response.status == ApiStatus.ERROR) {
      this.uiManagerService.notify('An error has occurred. Try again.');
    }

    return response.status;

  }

  downloadQRCodes(equipmentOrFieldService: Equipment | FieldService) {

    if (equipmentOrFieldService instanceof Equipment) {
      this.restApiManager.getFile(
        `${environment.restApi.endpoint}/equipment_models/${equipmentOrFieldService.id}/equipments/qrcodes`,
        `equipment-${equipmentOrFieldService.name.toLowerCase().replace(' ', '-')}-qr-codes.pdf`,
        this.accountManager.account.authToken
      );
    }

    if (equipmentOrFieldService instanceof FieldService) {
      this.restApiManager.getFile(
        `${environment.restApi.endpoint}/field_services/${equipmentOrFieldService.id}/equipments/qrcodes`,
        `field-service-${equipmentOrFieldService.name.toLowerCase().replace(' ', '-')}-qr-codes.pdf`,
        this.accountManager.account.authToken
      );
    }

  }

}
